<div class="form-group" [class.focused] = "amount">
    <input type="tel" class="form-control price"
    [readonly]="readonly"
    maxlength="20"
    (keyup)="pricePattern($event)"
    [(ngModel)]= "amount"
    [class.form-error] = "hasError"
    required>
    <span class="floating-label">{{priceTitle}}</span>
    <span class="rialSpan">ریال</span>
    <span class="star" *ngIf="!optional">*</span>
    <span *ngIf="hasError" class="errorInput">پر کردن این فیلد الزامی است.</span>
</div>
